/**
 * Fetch util
 */
define(function(require, exports, module) {
    var $ = require('j');
    var config = require('config');
    var urlUtil = require('util/url.util');
    var user = require('user');
    var _ = require('underscore');

    module.exports = {
        fetch: (options = {}) => {
            const {
                data = {},
                success = _.identity,
                error = _.identity,
                ...rest
            } = options;

            const urlParams = _.omit(urlUtil.getURLParams(), 'js_fast_load');

            return $.ajax({
                ...rest,
                data: {
                    ...data,
                    ...urlParams,
                    t: user.get('role') === 'admin'
                        ? Date.now()
                        : config.get('requestStamp')
                },
                success,
                error
            });
        }
    };
});
